export class PolicyForm {
    public UserPNumber : string;
    public CategoryID : number;
    public PolicyID : string;
    public Title : string;
    public PolicyNumber : string;
    public PolicyNumberFormer : string;
    public FileName : string;
    public Active : string;
}
